/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/google-drive" */ '@atlassian/logo-third-party/google-drive'
		).then((m) => m.GoogleDriveIcon),
	{ moduleId: '@atlassian/logo-third-party/google-drive' },
);

const LazyForgePioGoogleDriveIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-google-drive-prod" */ './utils').then(
			(m) => m.ForgePioGoogleDriveIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon' },
);

const LazyForgePioGoogleDriveSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-google-drive-prod-search-result" */ './utils').then(
			(m) => m.ForgePioGoogleDriveSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGoogleDriveIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioGoogleDriveIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgePioGoogleDriveSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioGoogleDriveSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
